import { render, staticRenderFns } from "./app-bar.vue?vue&type=template&id=061d9f87&scoped=true"
import script from "./app-bar.vue?vue&type=script&lang=js"
export * from "./app-bar.vue?vue&type=script&lang=js"
import style0 from "./app-bar.vue?vue&type=style&index=0&id=061d9f87&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061d9f87",
  null
  
)

export default component.exports